import { ChangeLocationViewActions } from "../actions";

type LocationRouterState = {
  displayHeader: boolean;
  useNewUI: boolean;
  view: "list" | "map";
};

const INITIAL_STATE: LocationRouterState = {
  displayHeader: false,
  useNewUI: false,
  view: "list",
};

// This reducer will only be used until we move completely to new UI
export const LocationRouterReducer = (
  state: LocationRouterState = INITIAL_STATE,
  action: ChangeLocationViewActions
) => {
  switch (action.type) {
    case "@@LOCATION_ROUTER/CHANGE_DISPLAY_TOGGLE_LOCATION_VIEW_HEADER":
      return {
        ...state,
        displayHeader: action.payload
      }
    case "@@LOCATION_ROUTER/CHANGE_LOCATION_ROUTER_VIEW":
      return {
        ...state,
        view: action.payload,
      };
    case "@@LOCATION_ROUTER/CHANGE_USE_NEW_LOCATION_SELECTION_UI":
      return {
        ...state,
        useNewUI: action.payload,
      };
    default:
      return state;
  }
};
